const headerWithButtonsSection = document.querySelector('.--pre-section-header.--with-buttons')

if(headerWithButtonsSection) {
    const sectionsToShow = document.querySelectorAll(".s-estaters-filter-switch, .s-category-nav, .s-main-filter")
    const filterActions = headerWithButtonsSection.querySelector(".filter-actions")
    const opener = filterActions.querySelector(".s-selected-filters__opener")

    opener?.addEventListener("click", (e) => {
        e.preventDefault()
        filterActions.classList.add("--hidden")
        window.scrollTo({top: 0, behavior: "smooth"});
        sectionsToShow.forEach((section) => {
            section.classList.remove("d-none")
            section.style.display = ''
        })
    })
}
